export default {
  es: {
    newDate: 'Agendar nueva cita',
    today: 'Hoy',
    upcomming: 'Próximas',
    past: 'Pasadas',
    myAppoint: 'Mis citas',
    select: 'Selecciona la que desees solicitar.',
    selectDate: 'Selecciona el tipo y fecha deseada para la cita:',
    availableText: 'Estos son los horarios de citas disponibles para:',
    alertTitle: 'Sin disponibilidad',
    alertContent: 'No hay disponibilidad de citas para esta fecha.',
    appointmentCreated: 'Has agendado una cita',
    systemMsg: 'Mensaje del sistema',
    cancelQuote: 'Cancelar cita',
    close: 'Salir',
    confirmInfo: 'Confirmar la información',
    startVideoCall: 'Ingresar a la videollamada'
  },
  en: {
    newDate: 'Schedule new appointment',
    today: 'Today',
    upcomming: 'Upcoming',
    past: 'Past',
    myAppoint: 'My appointments',
    select: 'Select the one you want to request.',
    selectDate: 'Select the type and the desired date for the appointment:',
    availableText: 'These are the appointment times available for:',
    alertTitle: 'No availability',
    alertContent: 'No appointment availability for this date.',
    appointmentCreated: 'An appointment has been scheduled',
    systemMsg: 'System message',
    cancelQuote: 'Cancel appointment',
    close: 'Close',
    confirmInfo: 'Confirm info',
    startVideoCall: 'Start videocall'
  }
};
